import { ChevronRightIcon, cn } from '@playerbase/ui';

// ---------------------------------------------------------------------------
// Local disclosure used by feedback groups to expand a thread's
// replies. Page-local on purpose - if a second consumer appears we'll
// promote it into @playerbase/ui then.
//
// Controlled component: parent owns open/closed state so the group can
// seed the initial state from a "head bundle activity within 24h"
// rule and remember the user's toggle for the session.
// ---------------------------------------------------------------------------

interface DetailsToggleProps {
  open: boolean;
  onToggle: (next: boolean) => void;
  summary: string;
  // aria-controls target id - improves screen-reader association with
  // the disclosed region. The group component sets a unique value per
  // disclosure.
  controlsId: string;
}

export function DetailsToggle({
  open,
  onToggle,
  summary,
  controlsId,
}: DetailsToggleProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={() => onToggle(!open)}
      aria-expanded={open}
      aria-controls={controlsId}
      className={cn(
        'group inline-flex items-center gap-1.5 rounded px-1.5 py-0.5 text-xs font-medium',
        'text-text-muted hover:bg-surface-3 hover:text-text transition-colors',
      )}
    >
      <ChevronRightIcon
        size={10}
        className={cn('transition-transform', open ? 'rotate-90' : 'rotate-0')}
      />
      <span>{summary}</span>
    </button>
  );
}
